@if (asCard()) {
  @if (formattedSteps()?.length) {
    <mwe-basic-card class="d-block mb-4">
      <ng-container *ngTemplateOutlet="steps" />
    </mwe-basic-card>
  }
} @else {
  <ng-container *ngTemplateOutlet="steps" />
}

<ng-template #steps>
  @if (processTitle()) {
    <h1 class="text-center h3">{{ processTitle() | translate }}</h1>
  }

  @if (stepsTitle()) {
    <ng-content />
    <h2 class="h4">{{ stepsTitle() | translate }}</h2>
  }

  <ol class="steps p-0 mb-0 is-vertical steps-line">
    @for (item of formattedSteps(); track $index; let last = $last; let count = $count) {
      <li class="item">
        <div class="image" aria-hidden="true">
          <div class="bubble align-items-center justify-content-center d-flex bg-secondary-light white">
            @if (count === 1) {
              <i class="fa fa-check"></i>
            } @else {
              <div class="bubble-text text-center">{{ $index + 1 }}</div>
            }
          </div>
        </div>

        <div class="details">
          <div class="mb-3">
            <div
              class="h5"
              data-test="mwe-confirmation-view-detail-title"
              [innerHTML]="item.title | translate: item.translationParams"
            ></div>

            @for (label of item.label; track label) {
              <p
                class="text-break"
                [class.mb-3]="!last"
                [class.mb-n3]="last"
                [innerHTML]="label | translate: item.translationParams | safeHtml"
              ></p>
            }
          </div>
        </div>
      </li>
    }
  </ol>
</ng-template>
